"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightButton = exports.LeftButton = exports.HeaderWrapper = void 0;
const react_native_1 = require("react-native");
const native_1 = __importStar(require("styled-components/native"));
exports.HeaderWrapper = native_1.default.View `
  background-color: ${(props) => props.backgroundColor};
  width: 100%;
  flex-direction: row;
  height: ${react_native_1.Platform.OS === 'ios' ? 44 : 56}px;
  position: ${(props) => props.isRelativePosition ? 'relative' : 'absolute'};
  z-index: 1;
  align-items: center;
  justify-content: center;
  ${({ border, theme }) => border &&
    native_1.css `
      border-bottom-width: 1px;
      border-bottom-color: ${theme.bpCore.colors.neutral[300]};
    `}
  ${({ theme, isElevated }) => {
    if (isElevated) {
        return native_1.css `
        shadow-color: ${theme.bpCore.colors.black};
        shadow-offset: 0 0;
        shadow-opacity: 0.11;
        shadow-radius: 7px;
        elevation: 11;
      `;
    }
    return '';
}};
`;
exports.LeftButton = native_1.default.TouchableOpacity `
  position: absolute;
  left: 0;
  margin-left: 8px;
  height: 44px;
  width: 44px;
  align-items: center;
  justify-content: center;
  padding: 5px;
`;
exports.RightButton = native_1.default.TouchableOpacity `
  position: absolute;
  right: 0;
  margin-right: 8px;
  height: 44px;
  width: 44px;
  align-items: center;
  justify-content: center;
`;
